import React from 'react';
import { Loader2 } from 'lucide-react';
import type { ScanProgress as ScanProgressType } from '../../types/scanner';

interface ScanProgressProps {
  progress?: ScanProgressType;
  url: string;
}

export const ScanProgress: React.FC<ScanProgressProps> = ({ progress, url }) => {
  const percent = progress?.percentComplete || 0;

  return (
    <div className="card">
      <div className="card-header" style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-3)' }}>
        <Loader2 size={20} style={{ animation: 'spin 1s linear infinite' }} />
        Scanning in Progress
      </div>
      <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}>
        <div style={{ fontSize: 'var(--text-sm)', color: 'var(--color-muted)' }}>
          Scanning: <span style={{ fontWeight: 600, color: 'var(--color-fg)' }}>{url}</span>
        </div>

        {/* Progress bar */}
        <div style={{
          width: '100%',
          height: '24px',
          border: 'var(--border-thick)',
          backgroundColor: 'var(--color-bg)',
          position: 'relative',
        }}>
          <div style={{
            width: `${percent}%`,
            height: '100%',
            backgroundColor: 'var(--color-fg)',
            transition: 'width 0.3s ease',
          }} />
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 'var(--text-sm)', color: 'var(--color-muted)' }}>
          <span>{progress?.currentCheck || 'Initializing...'}</span>
          <span style={{ fontWeight: 700, fontFamily: 'var(--font-mono)' }}>{percent}%</span>
        </div>
      </div>
    </div>
  );
};

export default ScanProgress;
